<! --
/**
* SuiteCRM is a customer relationship management program developed by SalesAgility Ltd.
* Copyright (C) 2021 SalesAgility Ltd.
*
* This program is free software; you can redistribute it and/or modify it under
* the terms of the GNU Affero General Public License version 3 as published by the
* Free Software Foundation with the addition of the following permission added
* to Section 15 as permitted in Section 7(a): FOR ANY PART OF THE COVERED WORK
* IN WHICH THE COPYRIGHT IS OWNED BY SALESAGILITY, SALESAGILITY DISCLAIMS THE
* WARRANTY OF NON INFRINGEMENT OF THIRD PARTY RIGHTS.
*
* This program is distributed in the hope that it will be useful, but WITHOUT
* ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
* FOR A PARTICULAR PURPOSE. See the GNU Affero General Public License for more
* details.
*
* You should have received a copy of the GNU Affero General Public License
* along with this program.  If not, see http://www.gnu.org/licenses.
*
* In accordance with Section 7(b) of the GNU Affero General Public License
* version 3, these Appropriate Legal Notices must retain the display of the
* "Supercharged by SuiteCRM" logo. If the display of the logos is not reasonably
* feasible for technical reasons, the Appropriate Legal Notices must display
* the words "Supercharged by SuiteCRM".
*/
-->
<ng-container *ngIf="(vm$ | async) as vm">

    <div class="install-view-header">

        <div class="row mr-0">

            <div class="col-md-4 install-header-title-col">

                <div class="install-view-title record-view-name pl-4">
                    <scrm-label labelKey="LBL_WELCOME" module="install"></scrm-label>
                </div>
                <div class="install-view-subtitle record-view-title">
                    <scrm-label labelKey="LBL_INSTALL" module="install"></scrm-label>
                </div>

            </div>

            <div class="col-md-8 install-header-buttons-col">

                <div class="row mr-1 ml-1">

                    <div class="w-100 d-flex justify-content-end align-items-center">

                        <div class="w-100 install-header-options d-flex justify-content-end align-items-center pr-5">
                            <div class="label-container pr-2">
                                <label class="m-0 small">
                                    <scrm-label
                                        [labelKey]="store.getIgnoreSystemChecksField().definition.vname"></scrm-label>
                                </label>:
                            </div>
                            <div class="d-flex">
                                <div class="flex-grow-1 text-break">
                                    <scrm-field [field]="store.getIgnoreSystemChecksField()"
                                                [mode]="'edit'"
                                                [record]="vm.record"
                                                [type]="store.getIgnoreSystemChecksField().type">
                                    </scrm-field>
                                </div>
                            </div>
                        </div>

                        <div>
                            <scrm-action-group-menu
                                [actionContext]="getActionContext(vm.record)"
                                [config]="actionsAdapter"
                                buttonClass="settings-button"
                                klass="install-view-actions float-right"
                            >
                            </scrm-action-group-menu>
                        </div>

                    </div>

                </div>

            </div>

        </div>

    </div>
</ng-container>
